import React from 'react';
import Header from '../../components/common/Header';
import Footer from '../../components/common/Footer';
import HeroSection from './HeroSection';
import FeaturesList from './FeaturesList';
import PartnersSection from '../Home/PartnersSection';
import SEO from '../../components/common/SEO';

const FeaturesPage = () => {
  return (
    <div className="min-h-screen flex flex-col">
      <SEO
        title="Features"
        description="Discover the exceptional features that make Elixir honey unique. From traditional beekeeping methods to premium quality standards, explore what sets our Mediterranean honey apart."
        keywords="
          Elixir honey features,
          Mediterranean honey quality,
          traditional beekeeping methods,
          premium honey standards,
          honey production features,
          Elixir honey benefits,
          artisanal honey features
        "
      />
      <Header />
      <main className="flex-grow">
        <HeroSection />
        <FeaturesList />
        <PartnersSection />
      </main>
      <Footer />
    </div>
  );
};

export default FeaturesPage;